export enum CryptoInvoiceCloseReason {
  EXPIRED = 'EXPIRED',
  MANUAL = 'MANUAL',
  PAID = 'PAID'
}
